import React, { useState } from 'react';
import { Container, Typography, Box, Tabs, Tab, Paper } from '@mui/material';
import MatchManagement from '../forms/MatchManagement';
import PlayerManagement from '../forms/PlayerManagement';
import NewsManagement from '../forms/NewsManagement';
import Analytics from '../forms/Analytics';
import MerchandiseOrders from '../forms/MerchandiseOrders';

const AdminPanel = () => {
  const [currentTab, setCurrentTab] = useState(0);

  const handleTabChange = (event, newValue) => {
    setCurrentTab(newValue);
  };

  return (
    <Container maxWidth="lg" sx={{ mt: 4 }}>
      <Typography variant="h4" component="h1" gutterBottom>
        Admin Panel
      </Typography>
      <Paper elevation={3} sx={{ padding: 2, mt: 2 }}>
        <Tabs
          value={currentTab}
          onChange={handleTabChange}
          variant="scrollable"
          scrollButtons="auto"
          textColor="primary"
          indicatorColor="primary"
        >
          <Tab label="Matches" />
          <Tab label="Players" />
          <Tab label="News" />
          <Tab label="Analytics" />
          <Tab label="Merchandise Orders" />
        </Tabs>
        <Box mt={3}>
          {currentTab === 0 && <MatchManagement />}
          {currentTab === 1 && <PlayerManagement />}
          {currentTab === 2 && <NewsManagement />}
          {currentTab === 3 && <Analytics />}
          {currentTab === 4 && <MerchandiseOrders />}
        </Box>
      </Paper>
    </Container>
  );
};

export default AdminPanel;
